import React from "react";
import { Icon } from "@material-ui/core";
import {
	tierOneLimit,
	tieroOnePrice,
	tierTwoLimit,
	tierTwoPrice,
	tierThreePrice,
	setupFee,
} from "../../../../utils/constants";
import "../../Subscription.css";

const pricingTiers = [
	{ range: `1 - ${tierOneLimit}`, price: tieroOnePrice },
	{ range: `${tierOneLimit + 1} - ${tierTwoLimit}`, price: tierTwoPrice },
	{ range: `${tierTwoLimit + 1}+`, price: tierThreePrice },
];

const PricingTable = ({ subscriptionStatus, subscriptionSource }) => {

	return (
		<div className="subscription-section">
			<div className="subscription-section-header">
				<Icon className="subscription-section-icon">local_offer</Icon>
				<h2 className="subscription-section-title">Pricing Tiers</h2>
			</div>

			<div className="pricing-table-container">
				<div className="pricing-table-wrapper">
					<table className="pricing-table">
						<thead>
							<tr>
								<th>Number of Hosts</th>
								<th>Price per Host / Month</th>
							</tr>
						</thead>
						<tbody>
							{pricingTiers.map((tier) => (
								<tr key={tier.range}>
									<td>{tier.range}</td>
									<td>${tier.price}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>

			{subscriptionSource === "paypal" && subscriptionStatus && subscriptionStatus !== "INACTIVE" && (
				<div className="subscription-info-banner grandfathered">
					<Icon className="subscription-info-banner-icon grandfathered">loyalty</Icon>
					<div className="subscription-info-banner-text">
						<strong>PayPal plan:</strong> This subscription uses the PayPal billing plan, which can differ from the card prices above. PayPal also rejects host changes that cross a pricing tier, such as 3 hosts to 4. Contact support if you need to cross a tier.
					</div>
				</div>
			)}

			{subscriptionSource === "stripe" && subscriptionStatus && subscriptionStatus !== "INACTIVE" && (
				<div className="subscription-info-banner">
					<Icon className="subscription-info-banner-icon">credit_card</Icon>
					<div className="subscription-info-banner-text">
						Card subscriptions use the prices in this table. Adding a host charges a prorated amount today. Removing a host takes effect on the next renewal.
					</div>
				</div>
			)}

			<div className="subscription-info-banner">
				<Icon className="subscription-info-banner-icon">info</Icon>
				<div className="subscription-info-banner-text">
					<strong>One-time Setup Fee:</strong> A ${setupFee} startup fee applies to all new subscriptions.
				</div>
			</div>
		</div>
	);
};

export default PricingTable;
